import {NgClass} from '@angular/common';
import {booleanAttribute, Component, EventEmitter, Input, Output} from '@angular/core';
import {KENDO_BUTTONS} from '@progress/kendo-angular-buttons';

//Composant bouton
@Component (
{
  selector: 'val-simple-bouton',
  imports:
  [
    NgClass,
    KENDO_BUTTONS
  ],
  templateUrl: './simple-bouton.component.html',
  styleUrl: './simple-bouton.component.scss'
})
export class SimpleBoutonComponent 
{
  //Création
  constructor ()
  {
    this.iconeClass = undefined;
    this.desactive = false;
    this.boutonClick = new EventEmitter<void> ();
  }

  //Libellé du bouton
  @Input ()
  public libelle!: string;

  @Input ()
  public iconeClass?: string;

  @Input ({transform: booleanAttribute})
  public desactive: boolean;

  //Evénement click
  @Output ()
  public boutonClick: EventEmitter<void>;

  //Click
  public Click () : void 
  {
    this.boutonClick.emit ();
  }
}
